import { useQuery } from '@apollo/client';
import { graphql } from '@client/graphql/types';
import { MenuSource } from '@client/graphql/types/graphql.ts';
import { useCompanyId } from '@packages/core/company/focused-company-context.ts';

export const MENU_LIST_QUERY = graphql(`
  query MenuList($companyId: ID!, $menuSources: [MenuSource!]!) {
    menus_v2(companyId: $companyId, menuSources: $menuSources) {
      id
      title
      menuSource
    }
  }
`);

export function useMenuList(menuSources: MenuSource[]) {
  const companyId = useCompanyId();

  return useQuery(MENU_LIST_QUERY, {
    variables: { companyId, menuSources: menuSources },
  });
}
